<template>
    <div class="card d-none row cardBemVindo">
        <div class="col-8">
            <h4>{{ $t('Bem Vindo(a)') }} {{ dsColaborador }}</h4>
            <p>{{ $t('Tenha acesso as principais') }} <br>{{ $t('informações da sua mecânica!') }}</p>
            <button class="btn btn-success">{{ $t('Ver OS internas') }}</button>
        </div>
        <div class="col-4 p-0">
            <img src="./dashboard.png" width="150" alt="">
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        dsColaborador() {
            const dsColaborador = this.$store.getters['filial/filial']

            return dsColaborador.dsColaborador.substring(0, 10)
        },
    },
}    
</script>

<style scoped>
    .cardBemVindo {
        flex-direction: row;
        align-items: flex-end;
        margin-right: 10px;
    }
</style>